import apiCall from "../../utils/api";
import {
    GET_SELECTED_DAMS,
    SET_SELECTED_DAMS,
    GET_LOG_ENTRIES,
    FETCH_LOG_ENTRIES,
    SET_LOG_ENTRIES,
    GET_TOTAL_ENTRIES,
    GET_PAGINATION_PAGE,
    SET_PAGINATION_PAGE,
    RESET_LOG_DATA
} from "../actions/reports";
import {AUTH_LOGOUT} from "../actions/auth";

const state = {
    selectedDams: [],
    logEntriesData: {},
    page: 1
};

const getters = {
    [GET_SELECTED_DAMS]: state => state.selectedDams,
    [GET_LOG_ENTRIES]: state => state.logEntriesData?.results || [],
    [GET_TOTAL_ENTRIES]: state => state.logEntriesData?.count || 0,
    [GET_PAGINATION_PAGE]: state => state.page || 1
};

const actions = {
    [SET_SELECTED_DAMS]: ({commit}, selectedDamsPayload) => commit(SET_SELECTED_DAMS, selectedDamsPayload),
    [FETCH_LOG_ENTRIES]: ({commit, dispatch}, data) => {
        return new Promise((resolve, reject) => {
            apiCall.getLogEntriesData(data)
                .then(resp => {
                    commit(SET_LOG_ENTRIES, resp);
                })
                .catch(err => {
                    console.log("ERROR in reports - get log entries data");
                    if (err.request.status === 401) {
                        // if resp is unauthorized, logout
                        dispatch(AUTH_LOGOUT);
                    }
                    reject(err); // WARNING - must be properly handled by caller!
                });
        });
    },
    [SET_PAGINATION_PAGE]: ({commit}, page) => commit(SET_PAGINATION_PAGE, page),
    [RESET_LOG_DATA]: ({commit}) => commit(RESET_LOG_DATA)
};

const mutations = {
    [SET_SELECTED_DAMS]: (state, selectedDamsPayload) => {
        state.selectedDams = selectedDamsPayload;
    },
    [SET_LOG_ENTRIES]: (state, resp) => {
        state.logEntriesData = resp.data;
    },
    [SET_PAGINATION_PAGE]: (state, page) => {
        state.page = page;
    },
    [RESET_LOG_DATA]: (state) => {
        state.logEntriesData = {};
        state.page = 1;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};